import { Component, OnInit } from '@angular/core';
import { TransactionStateEnum } from '../../shared/transaction/transaction-state.enum';
import { TransactionSummaryItemDto } from '../../shared/transaction/transaction-summary-item.dto';

@Component({
  selector: 'wl-credit-card-activity-details-dialog',
  templateUrl: './credit-card-activity-details-dialog.component.html',
  styleUrls: ['./credit-card-activity-details-dialog.component.less'],
    standalone: false
})
export class CreditCardActivityDetailsDialogComponent implements OnInit {
  show = false;
  transactionSummaryItem: TransactionSummaryItemDto;
  transactionStateEnum = TransactionStateEnum;

  constructor() {}

  ngOnInit(): void {}

  open(transactionSummaryItem: TransactionSummaryItemDto) {
    this.transactionSummaryItem = transactionSummaryItem;
    this.show = true;
  }
}
